"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrmvrMeterViewer = exports.isTrmvrMeterEmployee = exports.isTrmvrMeterEmployer = exports.isWorksiteDiaryUser = exports.isWorksiteDiarySupervisor = exports.isWorksiteDiaryMaster = exports.isCustomerAdmin = exports.isSuperAdmin = exports.isSokoBidUser = exports.isSokoBidAdmin = exports.isLightAdmin = exports.isProjectUser = exports.isProjectAdmin = exports.hasGrant = exports.LISTABLE_GRANT = exports.WORKSITE_DIARY_USER_GRANT = exports.WORKSITE_DIARY_MASTER_GRANT = exports.WORKSITE_DIARY_SUPERVISOR_GRANT = exports.TRMVRMETER_PREVIEW_GRANT = exports.TRMVRMETER_EMPLOYEE_GRANT = exports.TRMVRMETER_EMPLOYER_GRANT = exports.SOKOBID_USER_GRANT = exports.PROJECT_USER_GRANT = exports.SOKOBID_ADMIN_GRANT = exports.LIGHT_ADMIN_GRANT = exports.PROJECT_ADMIN_GRANT = exports.CUSTOMER_ADMIN_GRANT = exports.SUPER_ADMIN_GRANT = exports.FEATURE_MASK = exports.VIEWER_2D_PERM = exports.ORDER_PERM = exports.AUTOMATIC_ORDER_PERM = exports.SOKOSITE_PERM = exports.SOKOBID_PERM = exports.FILESTAB_PERM = exports.CONGRID_PERM = exports.PDFCOMPARE_PERM = exports.FILESTAB_PLUS_PERM = exports.SUBPROJECT_PERM = exports.VEKTORIO_PERM = exports.REGULAR_USER = exports.LIGHT_ADMIN = exports.SOKOBID_ADMIN = exports.PROJECT_ADMIN = exports.CUSTOMER_ADMIN = exports.SALESMAN = exports.SUPER_ADMIN = void 0;
exports.SUPER_ADMIN = 0x40000000 | 0x01;
exports.SALESMAN = 0x20000000;
exports.CUSTOMER_ADMIN = 0x10000000;
exports.PROJECT_ADMIN = 0x8000000;
exports.SOKOBID_ADMIN = 0x4000000;
exports.LIGHT_ADMIN = 0x2000000;
const TRMVRMETER_EMPLOYER = 0x400000;
const TRMVRMETER_EMPLOYEE = 0x200000;
const TRMVRMETER_PREVIEW = 0x100000;
const WORKSITE_DIARY_MASTER = 0x80000;
const WORKSITE_DIARY_SUPERVISOR = 0x40000;
const WORKSITE_DIARY_USER = 0x10000;
const SOKOBID_USER = 0x8000;
exports.REGULAR_USER = 0x4000;
exports.VEKTORIO_PERM = 0x1000;
exports.SUBPROJECT_PERM = 0x800;
exports.FILESTAB_PLUS_PERM = 0x400;
exports.PDFCOMPARE_PERM = 0x100;
exports.CONGRID_PERM = 0x80;
exports.FILESTAB_PERM = 0x40;
exports.SOKOBID_PERM = 0x20;
exports.SOKOSITE_PERM = 0x10;
exports.AUTOMATIC_ORDER_PERM = 0x08;
exports.ORDER_PERM = 0x04;
exports.VIEWER_2D_PERM = 0x02;
exports.FEATURE_MASK = exports.VEKTORIO_PERM |
    exports.SUBPROJECT_PERM |
    exports.FILESTAB_PLUS_PERM |
    exports.PDFCOMPARE_PERM |
    exports.CONGRID_PERM |
    exports.FILESTAB_PERM |
    exports.SOKOBID_PERM |
    exports.SOKOSITE_PERM |
    exports.ORDER_PERM |
    exports.AUTOMATIC_ORDER_PERM |
    exports.VIEWER_2D_PERM;
// project permission level grants
exports.SUPER_ADMIN_GRANT = exports.SUPER_ADMIN;
exports.CUSTOMER_ADMIN_GRANT = exports.SUPER_ADMIN | exports.CUSTOMER_ADMIN;
exports.PROJECT_ADMIN_GRANT = exports.SUPER_ADMIN | exports.PROJECT_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN;
exports.LIGHT_ADMIN_GRANT = exports.SUPER_ADMIN | exports.PROJECT_ADMIN | exports.CUSTOMER_ADMIN | exports.LIGHT_ADMIN | exports.SALESMAN;
exports.SOKOBID_ADMIN_GRANT = exports.SUPER_ADMIN | exports.SOKOBID_ADMIN | exports.SALESMAN;
exports.PROJECT_USER_GRANT = exports.SUPER_ADMIN | exports.PROJECT_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN | exports.REGULAR_USER;
exports.SOKOBID_USER_GRANT = exports.SUPER_ADMIN | exports.SOKOBID_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN | SOKOBID_USER;
exports.TRMVRMETER_EMPLOYER_GRANT = exports.SUPER_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN | TRMVRMETER_EMPLOYER;
exports.TRMVRMETER_EMPLOYEE_GRANT = exports.SUPER_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN | TRMVRMETER_EMPLOYEE;
exports.TRMVRMETER_PREVIEW_GRANT = exports.SUPER_ADMIN |
    exports.CUSTOMER_ADMIN |
    exports.SALESMAN |
    exports.PROJECT_ADMIN_GRANT |
    TRMVRMETER_PREVIEW;
exports.WORKSITE_DIARY_SUPERVISOR_GRANT = exports.SUPER_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN | WORKSITE_DIARY_SUPERVISOR;
exports.WORKSITE_DIARY_MASTER_GRANT = exports.SUPER_ADMIN | exports.CUSTOMER_ADMIN | exports.SALESMAN | WORKSITE_DIARY_MASTER;
exports.WORKSITE_DIARY_USER_GRANT = exports.SUPER_ADMIN |
    exports.CUSTOMER_ADMIN |
    exports.SALESMAN |
    exports.PROJECT_ADMIN_GRANT |
    WORKSITE_DIARY_USER;
exports.LISTABLE_GRANT = exports.SOKOBID_ADMIN_GRANT | exports.PROJECT_USER_GRANT;
const hasGrant = (perm, grant) => (perm && (perm & grant) === grant) || false;
exports.hasGrant = hasGrant;
const isProjectAdmin = (perm) => (perm & (exports.PROJECT_ADMIN_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isProjectAdmin = isProjectAdmin;
const isProjectUser = (perm) => (perm & (exports.PROJECT_USER_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isProjectUser = isProjectUser;
const isLightAdmin = (perm) => (perm & (exports.LIGHT_ADMIN_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isLightAdmin = isLightAdmin;
const isSokoBidAdmin = (perm) => (perm & (exports.SOKOBID_ADMIN_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isSokoBidAdmin = isSokoBidAdmin;
const isSokoBidUser = (perm) => (perm & (exports.SOKOBID_USER_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isSokoBidUser = isSokoBidUser;
const isSuperAdmin = (perm) => (perm & (exports.SUPER_ADMIN_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isSuperAdmin = isSuperAdmin;
const isCustomerAdmin = (perm) => (perm & (exports.CUSTOMER_ADMIN_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isCustomerAdmin = isCustomerAdmin;
const isWorksiteDiaryMaster = (perm) => (perm & (exports.WORKSITE_DIARY_MASTER_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isWorksiteDiaryMaster = isWorksiteDiaryMaster;
const isWorksiteDiarySupervisor = (perm) => (perm & (exports.WORKSITE_DIARY_SUPERVISOR_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isWorksiteDiarySupervisor = isWorksiteDiarySupervisor;
const isWorksiteDiaryUser = (perm) => (perm & (exports.WORKSITE_DIARY_USER_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isWorksiteDiaryUser = isWorksiteDiaryUser;
const isTrmvrMeterEmployer = (perm) => (perm & (exports.TRMVRMETER_EMPLOYER_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isTrmvrMeterEmployer = isTrmvrMeterEmployer;
const isTrmvrMeterEmployee = (perm) => (perm & (exports.TRMVRMETER_EMPLOYEE_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isTrmvrMeterEmployee = isTrmvrMeterEmployee;
const isTrmvrMeterViewer = (perm) => (perm & (exports.TRMVRMETER_PREVIEW_GRANT & ~exports.FEATURE_MASK)) !== 0;
exports.isTrmvrMeterViewer = isTrmvrMeterViewer;
//# sourceMappingURL=acl.js.map